export default __webpack_public_path__ + "static/media/07.2882d978.svg";